export type SpotLocationMode = 'hidden' | 'flash' | 'slow';

type SpotLocationConfig = {
  isLoading?: boolean;
  requestModelConfigId?: number | string;
  siteLocationFlag?: boolean;
  siteLocationType?: number;
};

export function getSlowFlashPlacePublicId(detail: { resourceSiteId?: number | string }) {
  return detail.resourceSiteId;
}

export function resolveSpotLocationMode(config: SpotLocationConfig, modelConfigId?: number | string): SpotLocationMode {
  if (config.isLoading) return 'hidden';
  if (modelConfigId !== undefined && config.requestModelConfigId !== modelConfigId) return 'hidden';
  if (config.siteLocationFlag === false) return 'hidden';
  if (config.siteLocationFlag === true && config.siteLocationType === 2) return 'slow';
  return 'flash';
}
